// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-button[data-v-0acfed7e]{position:absolute;right:0;top:0;font-size:14px;line-height:50px;width:30px;text-align:center;color:#00669f;transition:all .25s ease-in-out;transform:rotate(0)}.expand-button.expanded[data-v-0acfed7e]{transform:rotate(315deg) scale(1.25)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
